import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

import MapView from './MapView';
import BreadCrumbs from './BreadCrumbs';
import BookmarkButton from './BookmarkButton';
import AbendingForm from './AbendingForm';

import config from './../config';

class EinstaklingurView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/einstaklingar/';

		this.state = {
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		let params = [];

		this.setState({
			loading: true,
			listLoading: true
		});

		fetch(this.url+this.props.match.params.id+'/')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					loading: false
				});
			}.bind(this));


		fetch(config.apiRoot+'/ornefnaskrareinstaklings/?id='+this.props.match.params.id)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					ornefnaskrar: json.results,
					listLoading: false
				});
			}.bind(this));
	}

	render() {
		let item = this.state.data;

		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className={'column-content'+(this.state.loading ? ' loading' : '')}>
						{
							item &&
							<React.Fragment>

								{/*
								<BreadCrumbs path={[
									{
										path: '/einstaklingar/',
										title: 'Einstaklingar'
									},
									{
										path: item.id,
										title: item.nafn
									}
								]} />
								*/}

								<h3>
									{item.nafn}
									{
										item.aukanafn &&
										<small><br/>{item.aukanafn}</small>
									}
								</h3>
								<hr/>

								<div className="row">

									<div className="col col-md-8">
										{
											(item.faedingarar || item.danarar) &&
											<p>
												{
													item.faedingarar &&
													<React.Fragment><strong>Fæðingarár:</strong> {item.faedingarar}</React.Fragment>
												}
												{
													item.danarar &&
													<React.Fragment>{item.faedingarar && ' '}<strong>Dánarár:</strong> {item.danarar}</React.Fragment>
												}
											</p>
										}
										{
											item.faedingarstadur &&
											<p><strong>Fæðingarstaður:</strong> {item.faedingarstadur}</p>
										}
										{
											item.heimili &&
											<p><strong>Heimili:</strong> {item.heimili}</p>
										}

										<hr/>
										<h5>Tengdar örnefnaskrár</h5>

										<table className={'table'+(this.state.listLoading ? ' loading' : '')}>
											<thead>
												<tr>
													<th>Titill</th><th>Hlutverk</th><th></th>
												</tr>
											</thead>
											<tbody>
												{
													this.state.ornefnaskrar && this.state.ornefnaskrar.length > 0 &&
													this.state.ornefnaskrar.map((skra, index) => skra.ornefnaskra && skra.ornefnaskra.length > 0 && <tr key={index}>
														<td><Link to={'/ornefnaskra/'+skra.ornefnaskra[0].id}>{skra.ornefnaskra[0].titill}</Link></td><td>{(skra.hlutverk && skra.hlutverk.hlutverk ? skra.hlutverk.hlutverk : '')}</td><td><BookmarkButton title={skra.ornefnaskra.titill} id={skra.ornefnaskra.skra} baer={null} baer_id={null} type={'skra'} className="small" /></td>
													</tr>)
												}
											</tbody>
										</table>

									</div>

									<div className="col col-md-4">

										<AbendingForm entityId={item.id} entityType="einstaklingur" entityName={item.nafn}>
											<h3>Senda ábendingu</h3>
											<p>Senda ábendingu varðandi <strong>{item.nafn}</strong>.</p>
										</AbendingForm>

									</div>

								</div>

							</React.Fragment>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(EinstaklingurView);



// WEBPACK FOOTER //
// ./src/components/EinstaklingurView.js